export default (identifier, backend) =>
  window.localStorage.setItem(`backend_${identifier}`, backend);
